



import { Component, Vue } from 'vue-property-decorator';

import PartialAssets from '@/style-guide/partials/assets/assets.vue';
import PartialBtn from '@/style-guide/partials/btn/btn.vue';
import PartialButtonSwitch from '@/style-guide/partials/button-switch/button-switch.vue';
import PartialCheckbox from '@/style-guide/partials/checkbox/checkbox.vue';
import PartialSwitch from '@/style-guide/partials/switch/switch.vue';
import PartialExpansionPanel from '@/style-guide/partials/expansion-panel/expansion-panel.vue';
import PartialSelectTag from '@/style-guide/partials/selectTag/select.tag.vue';
import PartialShip from '@/style-guide/partials/ship/ship.vue';
import PartialConvocation from '@/style-guide/partials/convocation/convocation.vue';
import PartialCounter from '@/style-guide/partials/counter/counter.vue';
import PartialDatepicker from '@/style-guide/partials/datepicker/datepicker.vue';
import PartialDropdown from '@/style-guide/partials/dropdown/dropdown.vue';
import PartialDropUp from '@/style-guide/partials/dropUp/dropUp.vue';
import PartialEmptyState from '@/style-guide/partials/emptyState/emptyState.vue';
import PartialFlatSelectorIconSwitch from '@/style-guide/partials/flatSelectorIconSwitch/flatSelectorIconSwitch.vue';
import PartialFlatSelectorSwitch from '@/style-guide/partials/flat-selector-switch/index.vue';
import PartialFloatMenu from '@/style-guide/partials/float-menu/index.vue';
import PartialGroupFilter from '@/style-guide/partials/groupFilter/groupFilter.vue';
import PartialIcon from '@/style-guide/partials/icon/icon.vue';
import PartialInlineSpinner from '@/style-guide/partials/inline-spinner/inline-spinner.vue';
import PartialInput from '@/style-guide/partials/input/input.vue';
import PartialItemThumb from '@/style-guide/partials/item-thumb/item-thumb.vue';
import PartialModal from '@/style-guide/partials/modal/modal.vue';
import PartialNumberPicker from '@/style-guide/partials/number-picker/index.vue';
import PartialPagination from '@/style-guide/partials/pagination/pagination.vue';
import PartialSearch from '@/style-guide/partials/search/search.vue';
import PartialSearchAutocomplete from '@/style-guide/partials/searchAutocomplete/searchAutocomplete.vue';
import PartialSignaturePad from '@/style-guide/partials/signature-pad/index.vue';
import PartialSpotlightText from '@/style-guide/partials/spotlightText/spotlightText.vue';
import PartialSteps from '@/style-guide/partials/steps/index.vue';
import PartialTooltip from '@/style-guide/partials/tooltip/tooltip.vue';
import PartialTopBar from '@/style-guide/partials/topBar/topBar.vue';
import PartialTwoLevelsSelector from '@/style-guide/partials/twoLevelsSelector/twoLevelsSelector.vue';

@Component({
  components: {
    PartialAssets,
    PartialBtn,
    PartialButtonSwitch,
    PartialCheckbox,
    PartialSwitch,
    PartialExpansionPanel,
    PartialSelectTag,
    PartialShip,
    PartialConvocation,
    PartialCounter,
    PartialDatepicker,
    PartialDropdown,
    PartialDropUp,
    PartialEmptyState,
    PartialFlatSelectorIconSwitch,
    PartialFlatSelectorSwitch,
    PartialFloatMenu,
    PartialGroupFilter,
    PartialIcon,
    PartialInlineSpinner,
    PartialInput,
    PartialItemThumb,
    PartialModal,
    PartialNumberPicker,
    PartialPagination,
    PartialSearch,
    PartialSearchAutocomplete,
    PartialSignaturePad,
    PartialSpotlightText,
    PartialSteps,
    PartialTooltip,
    PartialTopBar,
    PartialTwoLevelsSelector,
  },
})
export default class StyleGuide extends Vue {}
